// extracted by mini-css-extract-plugin
export default {"error":"f_ac_Qsu","logo":"f_ae_1Yg","background":"f_af_p5B","return":"f_ag_nHB","glitch":"f_ah_EVG","glitchTop":"f_ai_Hfk","glitchBotom":"f_aj_29N"};